exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.form-wrapper[data-v-36908e2e] {\n  max-width: 400px;\n  margin: 0 auto;\n}\n", ""]);

// exports
